// src/components/App/AppBarOther.js

import React, { PureComponent } from "react";

import "./AppBarOther.css";
import getAssetBasePath from "./getAssetBasePath";

class AppBarOther extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showDescription: false,
    };
  }

  getIcon(name) {
    switch (name) {
      case "my-portfolio-hub":
        return "PieLeftSlice.svg";
      case "portfolio-analysis":
        return "ChartCombo.svg";
      case "fund-comparison":
        return "PieRightSlice.svg";
      case "capital-gains-comparison":
        return "Speedometer.svg";
      case "morningstar-ratings":
        return "Sunshine.svg";
      case "fibb":
        return "Barbell.svg";
      case "performance-at-a-glance":
        return "DoubleLineChart.svg";
      case "index-attribution":
        return "BarChart.svg";
      case "custom-models":
        return "BarChartFilled.svg";
      case "fund-attribution":
        return "Pillow-Chart-1.svg";
      case "barbell":
        return "share.svg";
      case "yield":
        return "share.svg";
      case "models":
        return "share.svg";
      case "dashboard":
        return "share.svg";
      case "befi":
        return "share.svg";
      case "fundlist":
        return "share.svg";
      case "taxport":
        return "share.svg";
      case "earnings":
        return "Money.svg";
      default:
        return "";
    }
  }

  render() {
    const { title, description, name, activeApp, link } = this.props;
    const assetBasePath = getAssetBasePath();
    let appStyle = "otherBarStyle";
    let columnClass = "col-md-4";
    let iconHolderStyle = "iconHolderStyle";
    // let titleStyle = 'titleStyle'
    let aniStyle = "aniStyle";
    let closeStyle = "closeStyle";
    // let iconStyle = 'iconStyle'
    let iconStyle2 = "iconStyle2";

    return (
      <div className={columnClass + " " + aniStyle}>
        <div
          id={`${name}-header`}
          className={`${appStyle} barLikeLink`}
          role="link"
          tabIndex={0}
          aria-label={`${title} – ${description}`}
          onClick={() => {
            window.location.href = link;
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              window.location.href = link;
            }
          }}
        >
          {activeApp === name && <div className={closeStyle}>&nbsp;</div>}
          {activeApp === "" && <div className={closeStyle}>&nbsp;</div>}
          {/* Uncomment to use custom icon per app
          <div className={iconHolderStyle}>
            <img
              className={iconStyle}
              src={`${process.env.REACT_APP_BASE_URL}icons/${this.getIcon(name)}`}
              alt={`${title} icon`}
            />
          </div>
          */}
          <div className={"bar-other-titleStyle"}>{title}</div>
          {activeApp !== name && (
            <div className={"bar-other-descriptionStyle"}>{description}</div>
          )}
          <div className={iconHolderStyle}>
            <img
              className={iconStyle2}
              src={`${assetBasePath}/iconsOff/ArrowRight.svg`}
              alt="Arrow right icon"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AppBarOther;



// WEBPACK FOOTER //
// ./src/components/App/AppBarOther.js